import React from "react";
import { Table } from "antd";

export default function TableView({
  hasTableFilters,
  renderTableFilterChips,
  clearTableFilters,
  columns,
  filteredData,
  loading,
  tablePagination,
  handleTableChange,
  handleRowClick,
  isDark,
}) {
  return (
    <>
      <div className="status-row">
        <span className="status-chip sort">
          <span className="status-label">Filters</span>
        </span>
        {hasTableFilters ? renderTableFilterChips() : <span className="status-chip none">None</span>}
        {hasTableFilters && (
          <span className="status-chip clear" onClick={clearTableFilters}>
            Clear
          </span>
        )}
      </div>
      <div
        className="table-responsive luxe-table"
        style={{
          marginTop: 20,
          background: isDark ? "#000" : "#fff",
          borderRadius: 14,
          boxShadow: "0 4px 24px 0 rgba(40, 30, 90, 0.18)",
        }}
      >
        <Table
          columns={columns}
          dataSource={filteredData}
          loading={loading}
          pagination={tablePagination}
          rowKey="id"
          onRow={(record) => ({ onClick: () => handleRowClick(record) })}
          className="luxe-table"
          onChange={handleTableChange}
        />
      </div>
    </>
  );
}
